export default __webpack_public_path__ + "static/media/changePasswordByPatientSuccess.afce5cee.svg";